var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWalletFlame = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 30C53 28.5082 52.4074 27.0774 51.3525 26.0225C50.2976 24.9676 48.8668 24.375 47.375 24.375H38C38 26.3641 37.2098 28.2718 35.8033 29.6783C34.3968 31.0848 32.4891 31.875 30.5 31.875C28.5109 31.875 26.6032 31.0848 25.1967 29.6783C23.7902 28.2718 23 26.3641 23 24.375H13.625C12.1332 24.375 10.7024 24.9676 9.64752 26.0225C8.59263 27.0774 8 28.5082 8 30M53 30V45C53 46.4918 52.4074 47.9226 51.3525 48.9775C50.2976 50.0324 48.8668 50.625 47.375 50.625H13.625C12.1332 50.625 10.7024 50.0324 9.64752 48.9775C8.59263 47.9226 8 46.4918 8 45V30M53 30V22.5M8 30V22.5M53 22.5C53 21.0082 52.4074 19.5774 51.3525 18.5225C50.2976 17.4676 48.8668 16.875 47.375 16.875H13.625C12.1332 16.875 10.7024 17.4676 9.64752 18.5225C8.59263 19.5774 8 21.0082 8 22.5M53 22.5V15C53 13.5082 52.4074 12.0774 51.3525 11.0225C50.2976 9.96763 48.8668 9.375 47.375 9.375H13.625C12.1332 9.375 10.7024 9.96763 9.64752 11.0225C8.59263 12.0774 8 13.5082 8 15V22.5",
    stroke: "url(#paint0_linear_10328_1374)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10328_1374",
    x1: 30.5,
    y1: 9.375,
    x2: 30.5,
    y2: 50.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF14EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC416"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWalletFlame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet-flame.85ad270fb670bb44bd32f01c051eed53.svg";